import { RecognitionResult } from "../redux/store/check/type";

export const ocrAmount = (recognitionResult: RecognitionResult) => {
  const ocrResults = {};
  recognitionResult.Response.Fields.Field.forEach((field: any) => {
    ocrResults[field.Name] = field;
  });

  return ocrResults.Amount.Value;
}

export const ocrAmountConfidence = (recognitionResult: RecognitionResult) => {
  const ocrResults = {};
  recognitionResult.Response.Fields.Field.forEach((field: any) => {
    ocrResults[field.Name] = field;
  });

  return ocrResults.Amount.Confidence;
}

export const payerName = (recognitionResult: RecognitionResult) => {
  const ocrResults = {};
  recognitionResult.Response.Fields.Field.forEach((field: any) => {
    ocrResults[field.Name] = field;
  });

  const payor = {};
  let payerName = "";
  if (ocrResults.PayorNameAndAddress && ocrResults.PayorNameAndAddress.Payor_Parsed) {
    ocrResults.PayorNameAndAddress.Payor_Parsed.Param.forEach(param => {
      payor[param.Name] = param;
    });
    payerName = payor.Name1.Value || "";
  }

  return payerName;
}

export const payerNameConfidence = (recognitionResult: RecognitionResult) => {
  const ocrResults = {};
  recognitionResult.Response.Fields.Field.forEach((field: any) => {
    ocrResults[field.Name] = field;
  });

  const payor = {};
  let payerNameConfidence = 0;
  if (ocrResults.PayorNameAndAddress && ocrResults.PayorNameAndAddress.Payor_Parsed) {
    ocrResults.PayorNameAndAddress.Payor_Parsed.Param.forEach(param => {
      payor[param.Name] = param;
    });
    payerNameConfidence = payor.Name1.Confidence || 0;
  }

  return payerNameConfidence;
}